module.exports = __webpack_public_path__ + "static/media/feedly.15c42d97.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/feedly.png
 ** module id = 217
 ** module chunks = 0
 **/